import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getPengaturan = 'pengaturan-iuran';
const postPengaturanUrl = 'pengaturan-iuran';
const putPengaturan = 'pengaturan-iuran/';
const getDetail = 'pengaturan-iuran/';
const deletePengaturan = 'pengaturan-iuran/';
const getSelectPengaturan = 'pengaturan-select'
class PengaturanService {

    getDetail(id) {
        return axios.get(
            API_URL + getDetail + id ,
            { headers: authHeader() }
        );
    }

    getPengaturanSelect() {
        return axios.get(
            API_URL + getSelectPengaturan ,
            { headers: authHeader() }
        );
    }

    postPengaturan(formData) {
        return axios
            .post(
                API_URL + postPengaturanUrl,
                formData,
                { headers: authHeader() }
            );
    }

    putPengaturan(formData) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + putPengaturan + formData.idPengaturanIuran, formData,
                { headers: authHeader() }
            );
    }

    deletePengaturan(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePengaturan + formData.id_pengaturan_iuran,
                { headers: authHeader() }
            );
    }
    
    getPengaturan(currentPage, pageSize, filter, tahun){
        
        return axios.get(
            API_URL + getPengaturan + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter + '&tahun='+tahun,
            { headers: authHeader() 
        });
    }

}

export default new PengaturanService();